import type { Module } from "@/lib/permissions";

export interface FinanceNavigationItem {
  id: "banking" | "ap" | "ar" | "contributions" | "funds" | "recurring-giving" | "budgets" | "reports" | "accounting" | "settings" | "approval-policies" | "fund-transfers" | "depreciation" | "purchase-orders" | "payroll" | "dashboard" | "vendor-1099" | "close" | "journals" | "recurring-expenses";
  label: string;
  href: string;
  requiredModule: Module;
}

/**
 * Canonical Finance IA entry points.
 * Keep this list in sync with App routes and report drilldowns.
 */
export const FINANCE_IA_ITEMS: FinanceNavigationItem[] = [
  { id: "banking", label: "Banking", href: "/finance/banking", requiredModule: "contributions" },
  { id: "ap", label: "Accounts Payable", href: "/finance/ap", requiredModule: "contributions" },
  { id: "ar", label: "Accounts Receivable", href: "/finance/ar", requiredModule: "contributions" },
  { id: "contributions", label: "Contributions", href: "/contributions", requiredModule: "contributions" },
  { id: "funds", label: "Funds", href: "/funds", requiredModule: "funds" },
  { id: "recurring-giving", label: "Recurring Giving", href: "/finance/recurring-giving", requiredModule: "contributions" },
  { id: "budgets", label: "Budgets", href: "/finance/budgets", requiredModule: "funds" },
  { id: "reports", label: "Reports", href: "/finance/reports", requiredModule: "reports" },
  { id: "journals", label: "Journals", href: "/finance/journals", requiredModule: "contributions" },
  { id: "recurring-expenses", label: "Recurring Expenses", href: "/finance/recurring-expenses", requiredModule: "contributions" },
  { id: "accounting", label: "Accounting", href: "/finance/accounting", requiredModule: "contributions" },
  { id: "settings", label: "Finance Settings", href: "/finance/settings", requiredModule: "contributions" },
  { id: "approval-policies", label: "Approval Policies", href: "/finance/settings/approval-policies", requiredModule: "contributions" },
  { id: "fund-transfers", label: "Fund Transfers", href: "/finance/fund-transfers", requiredModule: "contributions" },
  { id: "depreciation", label: "Depreciation", href: "/finance/depreciation", requiredModule: "contributions" },
  { id: "purchase-orders", label: "Purchase Orders", href: "/finance/purchase-orders", requiredModule: "contributions" },
  { id: "payroll", label: "Payroll", href: "/finance/payroll", requiredModule: "contributions" },
  { id: "dashboard", label: "Dashboard", href: "/finance/dashboard", requiredModule: "contributions" },
  { id: "vendor-1099", label: "1099 Preparation", href: "/finance/vendor-1099", requiredModule: "contributions" },
  { id: "close", label: "Close", href: "/finance/close", requiredModule: "contributions" },
];
